module.exports = __webpack_public_path__ + "img/carrot-and-coriander-soup.4f0de351.jpg";